import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, SparklesIcon, CrownIcon } from 'lucide-react';
export function OffersSection() {
  return <section className="py-8 md:py-24 bg-beige relative overflow-hidden border-y border-gray-200" data-id="element-247">
      {/* Background Pattern */}
      <div className="absolute inset-0 pattern-dots opacity-30 pointer-events-none" data-id="element-248"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-249">
        <div className="text-center mb-10 md:mb-16" data-id="element-250">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-heading font-bold text-jet mb-4" data-id="element-251">
            Special Offers
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-burgundy mx-auto rounded-full mb-6" data-id="element-252"></motion.div>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-jet/70 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-253">
            Mention these deals when you visit — walk-ins welcome!
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-254">
          {/* Card 1: $10 OFF */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative overflow-hidden rounded-xl shadow-2xl group" data-id="element-255">
            <div className="absolute inset-0 bg-gradient-to-br from-golden via-brand-orange to-[#CC5500] opacity-90" data-id="element-256"></div>
            <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/vuTG195XiLqBgVUgSo55rG/istockphoto-1328500183-612x612.webp')] bg-cover bg-center mix-blend-overlay opacity-20 transition-transform duration-700 group-hover:scale-110" data-id="element-257"></div>

            <div className="relative p-10 md:p-14 flex flex-col items-center text-center h-full" data-id="element-258">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6 backdrop-blur-sm border border-white/30" data-id="element-259">
                <SparklesIcon className="w-8 h-8 text-white" data-id="element-260" />
              </div>

              <h3 className="text-6xl md:text-7xl font-heading font-bold text-white mb-2 drop-shadow-lg" data-id="element-261">
                $10 OFF
              </h3>
              <p className="text-2xl md:text-3xl font-medium text-white/90 mb-8 font-heading italic" data-id="element-262">
                On All Braids $80+
              </p>

              <div className="mt-auto pt-8 w-full" data-id="element-263">
                <a href="tel:3013858034" className="flex items-center justify-center w-full bg-white text-brand-orange hover:bg-cream hover:text-burgundy px-8 py-4 rounded-sm font-bold transition-all shadow-lg text-lg uppercase tracking-wider gap-2 group-hover:shadow-xl" data-id="element-264">
                  <PhoneIcon className="w-5 h-5" data-id="element-265" />
                  Call to Claim
                </a>
              </div>
            </div>
          </motion.div>

          {/* Card 2: $20 OFF */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative overflow-hidden rounded-xl shadow-2xl group" data-id="element-266">
            <div className="absolute inset-0 bg-gradient-to-br from-burgundy via-[#601010] to-jet opacity-90" data-id="element-267"></div>
            <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/4HrN3tu5KNpG8RhMYChL1b/istockphoto-1352674262-612x612.webp')] bg-cover bg-center mix-blend-overlay opacity-20 transition-transform duration-700 group-hover:scale-110" data-id="element-268"></div>

            <div className="relative p-10 md:p-14 flex flex-col items-center text-center h-full" data-id="element-269">
              <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-6 backdrop-blur-sm border border-white/20" data-id="element-270">
                <CrownIcon className="w-8 h-8 text-golden" data-id="element-271" />
              </div>

              <h3 className="text-6xl md:text-7xl font-heading font-bold text-golden mb-2 drop-shadow-lg" data-id="element-272">
                $20 OFF
              </h3>
              <p className="text-2xl md:text-3xl font-medium text-white/90 mb-8 font-heading italic" data-id="element-273">
                On All Braids $180+
              </p>

              <div className="mt-auto pt-8 w-full" data-id="element-274">
                <a href="tel:3013858034" className="flex items-center justify-center w-full bg-golden text-jet hover:bg-gold-muted px-8 py-4 rounded-sm font-bold transition-all shadow-lg text-lg uppercase tracking-wider gap-2 group-hover:shadow-xl" data-id="element-275">
                  <PhoneIcon className="w-5 h-5" data-id="element-276" />
                  Call to Claim
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}